/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type resetPassword_viewer$ref: FragmentReference;
declare export opaque type resetPassword_viewer$fragmentType: resetPassword_viewer$ref;
export type resetPassword_viewer = {|
  +id: string,
  +actualPersonId: ?string,
  +lastName: ?string,
  +$refType: resetPassword_viewer$ref,
|};
export type resetPassword_viewer$data = resetPassword_viewer;
export type resetPassword_viewer$key = {
  +$data?: resetPassword_viewer$data,
  +$fragmentRefs: resetPassword_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "resetPassword_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
// prettier-ignore
(node/*: any*/).hash = 'ad4457293fa6ac134ece3729231f7fcf';

module.exports = node;
